package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.series.SimpleQuestionSeriesDto
import com.exura.features.plandefinition.domain.model.series.SimpleQuestionSeries
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between SimpleQuestionSeries domain model and DTO.
 * Implements BaseSeriesMappers for Firebase storage compatibility.
 */
class SimpleQuestionSeriesMappers : BaseSeriesMappers<SimpleQuestionSeries, SimpleQuestionSeriesDto> {
    override fun toDto(model: SimpleQuestionSeries): SimpleQuestionSeriesDto = SimpleQuestionSeriesDto(
        name = model.title,
        description = model.description,
        seriesType = model.seriesSpawnType,
        durationInDays = model.durationInDays(),
        relativeDay = model.relativeDay,
        duration = model.durationInDays(),
        question = model.question,
        options = model.options.map {
            SimpleQuestionSeriesDto.QuestionOptionDto(
                id = it.id,
                text = it.text,
                responseMessage = it.responseMessage,
                isResponsePositive = it.isResponsePositive,
            )
        },
        imageUrl = model.imageUrl,
        estimatedMinutes = model.estimatedMinutes,
        reaskEveryDays = model.reaskEveryDays,
    )

    override fun toDomain(dto: SimpleQuestionSeriesDto, collection: CollectionReference?, id: String?): SimpleQuestionSeries = SimpleQuestionSeries(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        title = dto.name,
        description = dto.description,
        relativeDay = dto.relativeDay,
        elements = emptyList(), // Elements would be loaded separately
        duration = dto.duration,
        question = dto.question,
        options = dto.options.map {
            SimpleQuestionSeries.QuestionOption(
                id = it.id,
                text = it.text,
                responseMessage = it.responseMessage
            )
        },
        imageUrl = dto.imageUrl,
        estimatedMinutes = dto.estimatedMinutes,
        reaskEveryDays = dto.reaskEveryDays,
    )
}
